module.exports={maps:[12,13,14,15],graph:[1,2,4,6,7,8,9,17,18,20,21,22,23,24,40,36,37,38,39,41],list:[3,10,25,26,19]};